// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3a0S_","list":"BalanceDue_list__YB-4M","listRow":"BalanceDue_listRow__1TnYq","total":"BalanceDue_total__FV7PC"};